import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'green' | 'red' | 'blue' | 'purple' | 'neutral';
  size?: 'sm' | 'md';
}

const variantClasses: Record<string, string> = {
  green:   'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20',
  red:     'bg-red-500/10 text-red-400 border border-red-500/20',
  blue:    'bg-blue-500/10 text-blue-400 border border-blue-500/20',
  purple:  'bg-white/[0.06] text-slate-400 border border-slate-700',
  neutral: 'bg-slate-800 text-slate-400 border border-slate-700',
};

export function Badge({ children, variant = 'neutral', size = 'sm' }: BadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';
  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${variantClasses[variant]}`}>
      {children}
    </span>
  );
}

interface PnlBadgeProps {
  value: number;
  showSign?: boolean;
  suffix?: string;
}

export function PnlBadge({ value, showSign = true, suffix = '%' }: PnlBadgeProps) {
  const isPositive = value >= 0;
  const variant = isPositive ? 'green' : 'red';
  const sign = showSign && isPositive ? '+' : '';
  return (
    <Badge variant={variant}>
      {sign}{value.toFixed(2)}{suffix}
    </Badge>
  );
}
